import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { useNavigate } from "react-router-dom";


import { useAuthContext } from "../../context/AuthContext";
import removeClientSideStorage from "../../utils/functions";

export default function SummaryWithClientNamesModal({open,setOpen,message,handleSend,backUpQuery}:any) {



  const handleYes = () => {
      setOpen(false);
    handleSend(true,backUpQuery);
  };
  

  const handleNo=()=>{
    setOpen(false);
    handleSend(false,backUpQuery);
  }
  return (
    <Modal open={open} >
      <ModalDialog variant="outlined" role="alertdialog">
        <DialogTitle>
          <WarningRoundedIcon />
           {message}
        </DialogTitle>
        
        <Divider />
      
        <DialogActions>
          <Button
            variant="solid"
            sx={{ backgroundColor: "#074c90" }}
            onClick={ handleYes}
          >
          Yes
          </Button>

           <Button
            variant="solid"
            sx={{ backgroundColor: "#074c90" }}
            onClick={handleNo}
          >
          No
          </Button>
          
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
}
